<template>
    <div class="flex flex-col gap-2 border-t border-t-white border-b border-b-slate-200 px-4 py-4 lg:px-8 lg:py-6">
        <div class="flex justify-between items-center gap-2 lg:gap-8">
            <div>
                <div class="font-extrabold">
                    <slot name="title"> </slot>
                </div>

                <div v-if="$slots.description" class="text-sm text-slate-500">
                    <slot name="description"> </slot>
                </div>
            </div>
            <div class="shrink-0">
                <vx-toggle v-model="model" size="sm" />
            </div>
        </div>
        <animate-height v-if="$slots.default" :height="model ? 'auto' : 0" :animate-opacity="true">
            <div>
                <slot> </slot>
            </div>
        </animate-height>
    </div>
</template>
<script setup lang="ts">
import { VxToggle } from '@voxie/frontend-components';
import AnimateHeight from 'vue-animate-height';

const model = defineModel({ type: Boolean, default: false });
</script>
